
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const sliders = document.querySelectorAll('.slider')
for (slider of sliders) {
    slider.slick()
}
